import { createSlice } from '@reduxjs/toolkit';

// Type
const initialState = {
  showCreateFreebetsForm: false,
  showCancelFreebetsForm: false,
  showRevokeFreebetsForm: false,
};

const createFreebetsSlice = createSlice({
  name: 'createFreebets',
  initialState,
  reducers: {
    setShowCreateFreebetsForm: (state, { payload }) => {
      state.showCreateFreebetsForm = payload;
    },
    setShowCancelFreebetsForm: (state, { payload }) => {
      state.showCancelFreebetsForm = payload;
    },
    setShowRevokeFreebetsForm: (state, { payload }) => {
      state.showRevokeFreebetsForm = payload;
    },
  },
  extraReducers: {},
});

export const { reducer: createFreebetsReducer } = createFreebetsSlice;
export const { setShowCreateFreebetsForm, setShowCancelFreebetsForm, setShowRevokeFreebetsForm } =
  createFreebetsSlice.actions;
